module.exports = __webpack_public_path__ + "static/img/3951_phase_function_Paper_PointsHejduk_Prediction.65a6427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3951_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jdCE
// module chunks = 0